import React from 'react';
import styled from 'styled-components';

const SpinnerContainer = styled.div`
  min-width: 154px;
`;

export default SpinnerContainer;
